import { NgModule } from "@angular/core";

import { TogglePasswordDirective } from "./toggle-password.directive";

const DIRECTIVES = [TogglePasswordDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class TogglePasswordModule {}
